// 문의 폼 메일 발송. 기존 EmailJS 설정값이 유실되어 SlopeXcelerity Functions(dogopangInquiry)로 대체했다 (2026-09-28).
// 수신처는 서버에 고정(dogopang@dogopang.com)되어 있고, 문의자 이메일은 답장 주소로 들어간다.
const INQUIRY_ENDPOINT = 'https://asia-northeast3-slopexcelerity-81e30.cloudfunctions.net/dogopangInquiry';

// 실패 시 기존 EmailJS 와 같은 모양(error.text)으로 reject 해서 폼의 오류 표시 코드를 그대로 쓴다.
const inquiryError = (text) => Object.assign(new Error(text), { text });

export const sendInquiry = async (type, fields) => {
  let response;
  try {
    response = await fetch(INQUIRY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, fields })
    });
  } catch (error) {
    throw inquiryError('네트워크 오류가 발생했습니다.');
  }
  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.ok) {
    throw inquiryError(result.error || `서버 오류 (${response.status})`);
  }
  return result;
};
